import { render, staticRenderFns } from "./card-media-with-slider-losaprily.vue?vue&type=template&id=0184e9dd&scoped=true&"
import script from "./card-media-with-slider-losaprily.vue?vue&type=script&lang=js&"
export * from "./card-media-with-slider-losaprily.vue?vue&type=script&lang=js&"
import style0 from "./card-media-with-slider-losaprily.vue?vue&type=style&index=0&id=0184e9dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0184e9dd",
  null
  
)

export default component.exports